export default __webpack_public_path__ + "static/media/testimonial01.001ae984.jpg";